import React, { useState, useLayoutEffect, useRef } from 'react';
import { observable, makeAutoObservable } from 'mobx';
import { observer } from 'src/utils/mobx-react';
import { Iframe } from 'src/components/Iframe/Iframe';
import { Popup } from 'src/components/Popup/Popup';
import styled from '@emotion/styled';
import { SetDepositFinalViewProps, MessageData } from 'src/components/TopUpProcedure/RealexForm/helper';

export const RealexFrameWrapper = styled('div', { label: 'RealexFrameWrapper' })`
    position: relative;
    overflow: auto;
    width: 500px;
    -webkit-overflow-scrolling: touch;
    iframe {
        display: block;
        width: 100%;
        height: 570px;
        border: 0;
    }
`;

class RealexFrameState {
    @observable public id: number = 0;
    @observable public loaded: boolean = false;
    @observable public isPopupOpen: boolean = true;

    public constructor() {
        this.id++;
        makeAutoObservable(this);
    }

    public getDepositID = (formData: Record<string, string>): string | undefined => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        return formData.GP_DEPOSIT_ID || formData.DEPOSIT_ID;
    };

    public hideLoader = (): void => {
        this.loaded = true;
    };

    public hidePopup = (): void => {
        this.isPopupOpen = false;
    };
}

interface PropsType {
    formActionUrl: string;
    formData: Record<string, string>;
    type: string;
    setDepositFinalView: (value: SetDepositFinalViewProps) => void;
    onCancel: () => undefined;
}

export const RealexFrame = observer('RealexFrame', (props: PropsType): JSX.Element | null => {
    const [state] = useState(() => new RealexFrameState());

    const btnRef = useRef<HTMLButtonElement>(null);
    const formRef = useRef<HTMLFormElement>(null);

    useLayoutEffect(() => {
        if (formRef.current !== null) {
            formRef.current.submit();
        }
        if (btnRef.current !== null) {
            btnRef.current.click();
        }
    });

    // Comment may be removed after payments are tested
    // componentDidMount() {
    //     const { form } = this.props;
    //     const depositID = getDepositID(form.get('formData', Map()));
    //     if (depositID && depositID !== this.currentDepositId) {
    //         this.currentDepositId = depositID;

    //     }
    // }

    const { formData, formActionUrl, onCancel, setDepositFinalView } = props;

    const getFormName = (): string => {
        const iframeId = state.getDepositID(formData);
        if (iframeId !== undefined && iframeId !== '') {
            return `realexFrame_${iframeId}_${state.id}`;
        }
        throw new Error('No Iframe target Name');
    };

    const onMessage = (data: MessageData | string): void => {
        if (typeof data === 'string') {
            return;
        }

        switch (data.type) {
            case 'success':
                setDepositFinalView('success');
                state.hidePopup();
                break;
            case 'error':
                if (data.reason === 'declined') {
                    setDepositFinalView('declined');
                }

                setDepositFinalView('errorIframe');
                state.hidePopup();
                break;
        }
    };

    const fields = Object.keys(formData).map((key) => {
        return (
            <input
                type='hidden'
                key={key}
                name={key}
                value={formData[key]}
            />
        );
    });
    return (
        <Popup
            title='Authorization Step'
            priority={120000}
            active={state.isPopupOpen}
            onClose={onCancel}
        >
            <RealexFrameWrapper>
                <form
                    ref={formRef}
                    method='POST'
                    action={formActionUrl}
                    target={getFormName()}
                    style={{ display: 'none' }}
                >
                    {fields}
                    <button
                        type='submit'
                        ref={btnRef}
                    />
                </form>
                <Iframe
                    title='realex-frame'
                    name={getFormName()}
                    onMessage={onMessage}
                />
            </RealexFrameWrapper>
        </Popup>
    );
});
